import { signal } from '@angular/core';

export const isMirror = signal<boolean>(null);
export const isVipMirror = signal<boolean>(null);
